import { IPerformSearchProps } from './SearchEntries.types';

export const performSearch = ({ e, query, operatorMode, onSearch }: IPerformSearchProps) => {
  !!e && e.preventDefault();
  query.length > 1 && onSearch(query, operatorMode);
  return false;
};
